import { alpha, Stack, type StackProps, Typography } from '@mui/material';

export const EmptyListState = ({ sx }: Pick<StackProps, 'sx'>) => (
  <Stack
    sx={{
      px: { xs: 2, md: 3 },
      py: { xs: 2, md: 4 },
      backgroundColor: 'common.white',
      ...sx,
    }}
  >
    <Typography variant="subtitle1">No Results</Typography>
    <Typography
      variant="body2"
      sx={{
        color: (theme) => alpha(theme.palette.text.secondary, 0.75),
        pt: 1,
      }}
    >
      Adjust the map or clear your search to find teams
    </Typography>
  </Stack>
);
